import httpService from "../../utils/httpService"
import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {AppThunk} from "../../rootReducer"
import {getAccessToken} from "../../utils/common"

export type Axles = {
    axleCode: string
    axleName: string
}
export type TestType = {
    testTypeCode: string
    testTypeName: string
}
export type Test = {
    testCode: string
    testName: string
}
export type TestCosts = {
    dvsaTestCostID: number
    code: string
    test: string
    testType: string
    axle: string
    duration: 0
    charges: 0
}

type DvsaTest = {
    axleLoading: boolean
    axleData: Axles[]
    axleError: string
    testsLoading: boolean
    testsData: Test[]
    testsError: string
    testTypeLoading: boolean
    testTypeData: TestType[]
    testTypeError: string
    testCostsData: TestCosts[]
    testCostsLoading: boolean
    testCostError: string
}
const initialState: DvsaTest = {
    axleData: [],
    axleLoading: false,
    axleError: "",
    testsData: [],
    testsLoading: false,
    testsError: "",
    testTypeData: [],
    testTypeLoading: false,
    testTypeError: "",
    testCostsData: [],
    testCostsLoading: false,
    testCostError: "",
}
const dvsaTestSlice = createSlice({
    name: "dvsaTest",
    initialState,
    reducers: {
        axleShowLoader(state, action: PayloadAction<boolean>) {
            state.axleLoading = action.payload
        },
        setAxleData(state, action: PayloadAction<Axles[]>) {
            state.axleData = action.payload
        },
        setAxleError(state, action: PayloadAction<string>) {
            state.axleError = action.payload
        },
        testTypeLoader(state, action: PayloadAction<boolean>) {
            state.testTypeLoading = action.payload
        },
        setTestType(state, action: PayloadAction<TestType[]>) {
            state.testTypeData = action.payload
        },
        setTestTypeError(state, action: PayloadAction<string>) {
            state.testTypeError = action.payload
        },
        testsLoader(state, action: PayloadAction<boolean>) {
            state.testsLoading = action.payload
        },
        setTests(state, action: PayloadAction<Test[]>) {
            state.testsData = action.payload
        },
        setTestsError(state, action: PayloadAction<string>) {
            state.testsError = action.payload
        },
        testCostsLoader(state, action: PayloadAction<boolean>) {
            state.testCostsLoading = action.payload
        },
        setTestCosts(state, action: PayloadAction<TestCosts[]>) {
            state.testCostsData = action.payload
        },
        setTestCostsError(state, action: PayloadAction<string>) {
            state.testCostError = action.payload
        },
    },
})

export const {
    axleShowLoader,
    setAxleData,
    setAxleError,
    testTypeLoader,
    setTestType,
    setTestTypeError,
    testsLoader,
    setTests,
    setTestsError,
    testCostsLoader,
    setTestCosts,
    setTestCostsError,
} = dvsaTestSlice.actions
export default dvsaTestSlice.reducer

//axles
export const getAxles = (): AppThunk => (dispatch: any, getState) => {
    dispatch(axleShowLoader(true))
    httpService(getAccessToken(getState()))
        .get(`dvsa/axles`)
        .then(res => {
            dispatch(axleShowLoader(false))
            dispatch(setAxleData(res.data))
        })
        .catch(error => {
            dispatch(axleShowLoader(false))
            dispatch(setAxleError(error.response.data.Value.Error))
        })
}

//testtypes
export const getTestTypes = (): AppThunk => (dispatch: any, getState) => {
    dispatch(testTypeLoader(true))
    httpService(getAccessToken(getState()))
        .get(`dvsa/testtypes`)
        .then(res => {
            dispatch(testTypeLoader(false))
            dispatch(setTestType(res.data))
        })
        .catch(error => {
            dispatch(testTypeLoader(false))
            dispatch(setTestTypeError(error.response.data.Value.Error))
        })
}

//tests
export const getTests = (): AppThunk => (dispatch: any, getState) => {
    dispatch(testsLoader(true))
    httpService(getAccessToken(getState()))
        .get(`dvsa/tests`)
        .then(res => {
            dispatch(testsLoader(false))
            dispatch(setTests(res.data))
        })
        .catch(error => {
            dispatch(testsLoader(false))
            dispatch(setTestsError(error.response.data.Value.Error))
        })
}

//testCosts
export const getTestCosts = (): AppThunk => (dispatch: any, getState) => {
    dispatch(testCostsLoader(true))
    httpService(getAccessToken(getState()))
        .get(`dvsa/testcosts`)
        .then(res => {
            dispatch(testCostsLoader(false))
            dispatch(setTestCosts(res.data))
        })
        .catch(error => {
            dispatch(testCostsLoader(false))
            dispatch(setTestCostsError(error.response.data.Value.Error))
        })
}
